class Breadcrumb {
  constructor (element) {
    element.addEventListener('click', (event) => {
      if (document.referrer === element.href) {
        event.preventDefault()
        window.history.back()
      }
    })
  }
}

export default {
  selector: '.js-breadcrumb-link',
  Source: Breadcrumb
}
